import EpisodeDescription, {
  EpisodeDescriptionProps,
} from './EpisodeDescription';

export default EpisodeDescription;
export type { EpisodeDescriptionProps };
